/**
 * @fileoverview Action type constants for config.
 */
export const SET_GLOBAL_COST = "config/SET_GLOBAL_COST";
export const TOGGLE_GROUPS = "config/TOGGLE_GROUPS";
export const TOGGLE_PHASES = "config/TOGGLE_PHASES";
export const SET_PROJECT_NAME = "config/SET_PROJECT_NAME";
export const SET_LANGUAGE = "config/SET_LANGUAGE";
export const LOAD_STATE = "LOAD_STATE";
